import { warrenAnalyticsObject } from '@/plugins/warren-analytics';
import { trackerContextProps } from '@/modules/common/services/analytics/tracker-context';

export function trackRegister() {
  warrenAnalyticsObject.track({
    ...trackerContextProps(),
    event: 'Register Finished'
  });
}
